import { createContext, useContext } from 'react'

/**
 * Where a quick-write document opens from an artifact chip. The Assistant page
 * docks it beside the chat on wide screens; the assistant dock is too narrow to
 * hold a second panel, so it always opens the document as a sheet.
 */
export type ArtifactSurface = 'auto' | 'sheet'

export const ArtifactSurfaceContext = createContext<ArtifactSurface>('auto')

export function useArtifactSurface(): ArtifactSurface {
  return useContext(ArtifactSurfaceContext)
}
